import { LoanProposalStatus, Proposal } from "@cf247/pricing";

export default function useMapProposals(props: Proposal[], dealerId: number){
  if (!props || !Array.isArray(props)) {
    return [];
  }

  return props;
}